export enum ToolID {
  VIDEO_POPUP = 0,
  ON_DEMAND_HINT = 1,
  RUBRIC_POPUP = 2,
}
